var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"footer"},[_c('div',{staticClass:"logo float-right"},[_c('b-img',{staticClass:"logo-image",attrs:{"src":require('../../assets/FairmatLogoWhite.png'),"alt":"Fairmat"}})],1),_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.$t('footer'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }